export const debug: boolean = false;
